import TemplateToDomController from 'controllers/template_to_dom_controller';

export default class SelectableTemplateToDomController extends TemplateToDomController {
  public static values = {
    ...TemplateToDomController.values,
    selectId: String,
    optionText: String,
    optionValue: String,
  };

  declare protected selectIdValue: string;
  declare protected optionTextValue: string;
  declare protected optionValueValue: string;

  public onAdd(): void {
    const select = document.getElementById(this.selectIdValue);
    if (!select || !(select instanceof HTMLSelectElement)) {
      console.warn('[select] expected a selector with id:', this.idValue);
      return;
    }

    const selectValue = select.value;
    if (!selectValue) {
      console.warn('[select] expected a value but got:', selectValue);
      return;
    }

    const templateId = this.idValue + '-' + selectValue;

    const template = document.getElementById(templateId);
    if (!template || !(template instanceof HTMLTemplateElement)) {
      console.warn('[template] expected a template with id:', templateId);
      return;
    }

    const ids: Record<string, string> = {};
    if (this.hasVariableKeyValue && this.hasVariableValueValue) {
      const preSeed = this.variableValueValue.split(' ');
      this.variableKeyValue.split(' ').forEach((id, index) => {
        ids[id] = preSeed[index];
      });
    }

    const inflated = TemplateToDomController.inflate(template, ids);
    const [placement, query] = this.targetValue.split(':');

    let target: HTMLElement | null;

    switch (placement) {
      case 'replace':
      case 'after':
      case 'before': {
        target = this.element.closest(query) || document.querySelector(query);
        break;
      }

      case 'first': {
        target = document.querySelector(query);
        break;
      }
      case 'last': {
        const all = document.querySelectorAll(query);
        target = all.item(all.length - 1) as HTMLElement | null;
        break;
      }
      default: {
        console.warn(
          '[template] that placement modifier is not supported',
          placement,
        );
        return;
      }
    }

    if (!target) {
      console.warn('[template] expected a target for placement and query', {
        placement,
        query,
      });
      return;
    }

    // Remove the option from the <select> so templates cannot be added twice
    const options = select.getElementsByTagName('option');
    for (let i = options.length - 1; i >= 0; i--) {
      if (options[i].value == selectValue) {
        select.removeChild(options[i]);
      }
    }

    switch (placement) {
      case 'replace': {
        target.replaceWith(inflated);
        return;
      }

      case 'after': {
        target.after(inflated);
        return;
      }

      case 'before': {
        target.before(inflated);
        return;
      }

      case 'first':
      case 'last': {
        target.append(inflated);
        return;
      }
    }
  }

  /**
   * Inserts an option back in to the <select> element specified by id in alphabetical place and
   * remove the element/block this was called from
   */
  public onRemove(): void {
    const elementToRemove = this.element.closest('li');
    if (!elementToRemove) {
      console.warn('[removal] expected a parent element of type: <li>');
      return;
    }

    elementToRemove.remove();

    if (this.selectIdValue == '') {
      return;
    }

    const select = document.getElementById(this.selectIdValue);
    if (!select || !(select instanceof HTMLSelectElement)) {
      console.warn('[select] expected a selector with id:', this.idValue);
      return;
    }

    const newOption = document.createElement('option');
    newOption.value = this.optionValueValue;
    newOption.text = this.optionTextValue;

    const options = select.getElementsByTagName('option');
    if (options.length == 0) {
      select.appendChild(newOption);
    } else {
      for (let i = 0; i < options.length; i++) {
        if (newOption.text.toUpperCase() < options[i].text.toUpperCase()) {
          select.insertBefore(newOption, options[i]);
          break;
        } else if (i == options.length - 1) {
          select.appendChild(newOption);
        }
      }
    }
  }
}
